import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialReactTable from "material-react-table";
import { Grid, Typography } from "@mui/material";
// import { CustomersTableActionBar } from "./customers-table-action-bar";
import { AppDispatch } from "src/store";
import { UsersTableActionMenu } from "./user-table-action-menu";
import { fetchUsers } from "src/slices/users/thunk";
import { selectUsers } from "src/slices/users/selectors";
import { IUser } from "src/slices/users/type";
import { UsersTableActionBar } from "./user-table-action-bar";

export function UserListing() {
  const dispatch = useDispatch<AppDispatch>();
  const users = useSelector(selectUsers);

  const [columns] = useState<any>([
    {
      accessorKey: "firstName",
      header: "User Name",
    },
    {
      accessorKey: "role",
      header: "Role",
      Cell: ({ cell }) => (
        <Typography sx={{ overflow: "auto" }}>{cell?.getValue()?.[0]?.name}</Typography>
      ),
    },
    {
      accessorKey: "email",
      header: "EmailId",
    },
    {
      accessorKey: "mobile",
      header: "Mobile",
    },
    {
      accessorKey: "locations",
      header: "Branch",
      Cell: ({ cell }) => (
        <Typography sx={{ overflow: "auto" }}>{cell?.getValue()}</Typography>
      ),
    },
  ]);
  const [rows, setRows] = useState<any[]>([]);

  useEffect(() => {
    dispatch(fetchUsers());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (users && users.length > 0) {
      const tableRows = users?.map((user: IUser) => ({
        id: user.id,
        firstName: user.firstName,
        mobile: user.mobile,
        email: user.emailId,
        role: user.roles,
        isActive: user.isActive,
        locations: user.locations.reduce((acc: string, curr: any, index: number) => 
          acc + (index > 0 ? ', ' : '') + curr.name, 
          ''
        ),
      }));
      setRows(tableRows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  return (
    <Box sx={{ width: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MaterialReactTable
            columns={columns}
            data={rows}
            initialState={{
              density: "compact",
              pagination: { pageIndex: 0, pageSize: 100 },
            }}
            renderTopToolbarCustomActions={UsersTableActionBar}
            enableRowActions
            renderRowActionMenuItems={UsersTableActionMenu}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
